/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { ChooseApps, Buttons, Loader } from 'components';
import { useSelector, useDispatch } from 'react-redux';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
import { useParams } from 'react-router';
import { selectedTargetingApps } from 'store/selectors';

const ChooseAppsBtn = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { cmp_id } = useParams();

  let selectedApps = useSelector(selectedTargetingApps);
  selectedApps = selectedApps ? selectedApps.split(',').map(Number) : [];

  const { data: allApps, isLoading: allAppsIsLoading } =
    manageCampaignsAPI.useGetSearchAppsNewQuery({
      cm_id: cmp_id,
      term: null,
    });

  return (
    <>
      {allAppsIsLoading && <Loader.Global />}
      <Buttons.SecondaryNormal
        id='categories'
        style={{ width: '100%' }}
        onClick={() => setIsOpen(true)}
      >
        Choose Apps
      </Buttons.SecondaryNormal>
      {isOpen && (
        <ChooseApps
          title='Direct Buy Apps'
          close={() => setIsOpen(false)}
          isOpen={isOpen}
          allApps={Array.isArray(allApps) ? allApps : emptyArr}
          selectedApps={selectedApps}
        />
      )}
    </>
  );
};

export default ChooseAppsBtn;

const emptyArr = [];
